import { FunctionComponent } from 'react'
import ImageWrapper from './ImageWrapper'
import { AuthorProps } from './types'
import SingleAuthor from './SingleAuthor'
import styled from 'styled-components'

interface SingleAuthorProps {
  children: AuthorProps
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
`

const SingleAuthorWrapper: FunctionComponent<SingleAuthorProps> = ({
  children,
}) => {
  const { image, name, url, role, type } = children
  return (
    <Wrapper>
      {image && <ImageWrapper>{image}</ImageWrapper>}
      <SingleAuthor name={name} url={url} role={role} type={type} />
    </Wrapper>
  )
}

export default SingleAuthorWrapper
